import { render, staticRenderFns } from "./Kanban.vue?vue&type=template&id=58887c78&scoped=true&"
import script from "./Kanban.vue?vue&type=script&lang=js&"
export * from "./Kanban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58887c78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58887c78')) {
      api.createRecord('58887c78', component.options)
    } else {
      api.reload('58887c78', component.options)
    }
    module.hot.accept("./Kanban.vue?vue&type=template&id=58887c78&scoped=true&", function () {
      api.rerender('58887c78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectmanagement/Kanban.vue"
export default component.exports